import React from 'react'

export const BannerCutout = ({
  columnCount,
  angleBorder,
  angleType,
  angleBorderColor,
  bgClass,
  imageUrl,
  horizontalCrop,
  verticalCrop,
  isMobile,
  mobileImageUrl,
}) => {
  const gridSizeImage = {
    whole: 'u-hidden',
    fourths: 'u-size1of4',
    thirds: 'u-size1of3',
    halves: 'u-size1of2',
  }

  return (
    <div
      id="bannerCutout"
      className={`${gridSizeImage[columnCount]} u-posAbsolute u-sm-posRelative ${angleBorder} ${angleType} u-sm-sizeFull`}
    >
      <div className={`Shaddow2 ${bgClass} ${angleBorderColor}`}></div>
      <div className={`Shaddow1 ${bgClass} ${angleBorderColor}`}></div>
      <div className={`Clip ${bgClass}`}></div>
      {imageUrl && (
        <div
          id="bannerImage"
          className={`background-x-${horizontalCrop} background-y-${verticalCrop}`}
          style={{
            backgroundImage: `url("${isMobile ? mobileImageUrl || imageUrl : imageUrl}")`,
          }}
        ></div>
      )}
    </div>
  )
}
